// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lCkL","toggleWrap":"styles_toggleWrap__2ko0t","content":"styles_content__2ENIn","selectAreaCode":"styles_selectAreaCode__mnFbM"};